import Form from "../../../../components/forms/index";
import { useRetailerForm } from "../../../../hooks/shop/create-retailer-shop/useRetailerForm";

const RetailerForm = () => {
  const {
    createShop,
    setCreateShop,
    shopCategoryone,
    isCreating,
    isUploading,
    uploadProgress,
    displayimg,
    setDisplayimg,
    Shopdatas,
    PostShopData,
    getRootProps,
    getInputProps,
  } = useRetailerForm();

  return (
    <Form
      title="Fill to Create Retailer Shop"
      butn="Create"
      back="/retailer-integrate"
      CreateHandler={PostShopData}
      setCreateShop={setCreateShop}
      createShop={createShop}
      shopCategoryone={shopCategoryone}
      getInputProps={getInputProps}
      getRootProps={getRootProps}
      displayimg={displayimg}
      setDisplayimg={setDisplayimg}
      Shopdatas={Shopdatas}
      isUploading={isUploading}
      uploadProgress={uploadProgress}
      isSubmitting={isCreating}
    />
  );
};

export default RetailerForm;
